import { Menu, MenuItem, MenuButton } from '@szhsin/react-menu';
import cx from 'classnames';

import {
  RenderForGlobalExchange,
  RenderForIndianExchange,
} from 'components/render/RenderByExchangeType';
import {
  ANDROID_APK_URL,
  PLAY_STORE_URL,
  APP_STORE_URL,
  IS_INDIAN_EXCHANGE,
  IOS_APP_INDIA_URL,
} from 'constants/constants';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import i18n from 'i18n/config';
import AppStore from 'styles/assets/appStoreBadge.png';
import DeltaIndiaMobileAppQrCode from 'styles/assets/DeltaIndiaMobileAppQrCode.svg';
import DownloadAndroid from 'styles/assets/downloadandroid.svg';
import GooglePlay from 'styles/assets/googlePlayBadge.png';
import { MobileIcon } from 'styles/assets/icons';
import MobileAppQRCode from 'styles/assets/mobileAppQrCode.svg';
import Box from 'UIKit/Box';

import styles from './index.module.scss';

const HEADING_TEXT = i18n.t('headerFooter:header.downloadApp_india');

const MobileAppTab = () => {
  return (
    <Menu
      menuButton={({ open }) => (
        <MenuButton className={`${open ? styles.active : ''} ${styles.button}`}>
          <MobileIcon />
        </MenuButton>
      )}
      menuClassName={styles['mobile-app-container']}
    >
      <MenuItem className={styles[`tab-menu-item`]}>
        <div className={styles.heading}>{HEADING_TEXT}</div>
        <img
          src={IS_INDIAN_EXCHANGE ? DeltaIndiaMobileAppQrCode : MobileAppQRCode}
          alt="mobile_app_qr_code"
          width="135px"
          height="135px"
        />
        <Box className={styles['play-store']}>
          <a
            data-testid="play-store-icon"
            onClick={() =>
              trackMixpanelEvent('Android Download - Header', {
                page_name: 'All Markets Page',
              })
            }
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noreferrer"
          >
            <img src={GooglePlay} width="135px" height="40px" alt="google-play" />
          </a>
        </Box>
        <RenderForGlobalExchange>
          <Box className={styles.appStore}>
            <a
              data-testid="app-store-icon"
              onClick={() =>
                trackMixpanelEvent('iOS Download - Header', {
                  page_name: 'All Markets Page',
                })
              }
              href={APP_STORE_URL}
              target="_blank"
              rel="noreferrer"
            >
              <img src={AppStore} width="135px" height="40px" alt="app-store" />
            </a>
          </Box>
        </RenderForGlobalExchange>

        <Box
          className={cx(styles['play-store'], {
            [styles.downLoadAndroid_india]: IS_INDIAN_EXCHANGE,
          })}
        >
          <a
            data-testid="android-apk-icon"
            onClick={() =>
              trackMixpanelEvent('Android Download - Header', {
                page_name: 'All Markets Page',
              })
            }
            href={ANDROID_APK_URL}
            rel="noreferrer"
          >
            <img src={DownloadAndroid} width="135px" height="40px" alt="android-app" />
          </a>
        </Box>

        <RenderForIndianExchange>
          <Box className={styles.iosAppAlt}>
            <a
              data-testid="ios-app-alternative"
              onClick={() =>
                trackMixpanelEvent('IOS App Alternative - Header', {
                  page_name: 'All Markets Page',
                })
              }
              target="_blank"
              href={IOS_APP_INDIA_URL}
              rel="noreferrer"
            >
              <img src={AppStore} width="135px" height="40px" alt="ios-app-alternative" />
            </a>
          </Box>
        </RenderForIndianExchange>
      </MenuItem>
    </Menu>
  );
};

export default MobileAppTab;
